module.exports = __webpack_public_path__ + "static/media/print-free-icon2.149cf1a9.png";